const TopBanner = ({ banners, removeBanner }) => {
	return (
		<div className="top-banner-container-parent">
			<div className="top-banner-container">
				<div className="top-banner">
					{banners &&
						banners.map((Banner, index) => (
							<div
								className="banner"
								key={`top-banner-item-${index}`}
							>
								<Banner removeBanner={removeBanner(index)} />
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

export default TopBanner;
